import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ltv-calculator',
  component: () => import('../../routes/LtvCalculator.svelte'),
  card: {
    id: 'ltv',
    title: 'LTV Calculator',
    description:
      'Calculate your Loan-to-Value ratio to understand equity position, risk category, and available mortgage programs.',
    icon: 'percent',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/ltv-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'LTV (Loan-to-Value) Calculator – Equity & Risk Assessment',
    description:
      'Free LTV calculator to measure your loan-to-value ratio. Understand your equity position, risk category, and see which mortgage programs you qualify for.',
  },
};

export default meta;
